import {Routes, Route} from 'react-router-dom';

import './App.css';
import Footer from './Component/Footer';
import Navigation from './Component/Navigation';
import Header from './Component/Header';
import Home from './Home';
import About from './About';
import Social from './Component/Social';
import Contact from './Contact';
import Services from './Services';
import UVPrinting from './Services/UVPrinting';
import ScreenPrinting from './Services/ScreenPrinting';
import ThermalDecalPrinting from './Services/ThermalDecalPrinting';
import HotStampPrinting from './Services/HotStampPrinting';
// import Background from './Component/Background';

function App() {

  

  return (
    <div>
      
     <div><Navigation/></div>
     <div><Header/></div>
     <main>
    
      <Routes>
        
        <Route path='/' element={<Home/>}></Route>
        <Route path='/About' element={<About/>}></Route>
        <Route path='/Services/' element={<Services/>}></Route>
         <Route path='/Services/UVPrinting' element={<UVPrinting/>}></Route>
          <Route path='/Services/ScreenPrinting' element={<ScreenPrinting/>}></Route>
           <Route path='/Services/ThermalDecalPrinting' element={<ThermalDecalPrinting/>}></Route>
            <Route path='/Services/HotStampPrinting' element={<HotStampPrinting/>}></Route>
        <Route path='/Contact' element={<Contact/>}></Route>
      </Routes>

     </main>
     
{/* <div><Background/></div> */}
<div><Social/></div>
     <div className='mx-16 clear-both'><Footer/></div>
    </div>
  );
}

export default App;
